export const LEGAL_LINKS = {
  terms: "/legal/terms-of-service.html",
  privacy: "/legal/privacy-policy.html",
  refund: "/legal/refund-policy.html",
  cookies: "/legal/cookie-policy.html",
  acceptableUse: "/legal/acceptable-use-policy.html",
  community: "/legal/community-guidelines.html",
} as const;

export function openLegalDocument(url: string): void {
  window.open(url, "_blank", "noopener,noreferrer");
}
